<template>
    <div class="row" :id="table_id">
        <div class="col-12 main-data-table-container" style="overflow-x: auto;">
            <table class="table table-striped main-data-table">
                <thead class="main-thead">
                    <tr class="headers" style="text-align: center; cursor: pointer;">
                        <data-tables-header-column-component 
                            v-for="header in headers" 
                            :key="header.key" 
                            :col_key="header.key" 
                            :class="header.head_classes" 
                            :text="header.trans" 
                            :sorting_key="sorting_key" 
                            :sorting_direction="sorting_direction"
                        ></data-tables-header-column-component>
                    </tr>
                    <tr v-if="filter_header" class="filters">
                        <th v-for="header in headers" :key="header.key" :class="[header.head_classes]">
                            <input type="text" class="form-control filter-input-sm" v-if="header.filter_type == 'text'" v-on:input="filterInput()" v-model="filter_values[header.key]">
                            <input type="text" class="form-control filter-input-sm vue-datatables-daterange-filter" v-if="header.filter_type == 'date_range'" :data-header-key="header.key" v-model="filter_values[header.key]">
                            <select class="form-control filter-input-sm" v-if="header.filter_type == 'simple_select'" v-on:change="filterInput()" v-model="filter_values[header.key]">
                                <option v-for="(option_value, option_index) in JSON.parse(Base64.decode(header.filterData)).options" :key="option_index" :value="option_index">
                                    {{ option_value }}
                                </option>
                            </select>
                            <div v-if="header.key === 'selector_input'" class="d-flex justify-content-center">
                                <div class="custom-control custom-switch pl-5">
                                    <input type="checkbox" class="custom-control-input" :value="1" v-model="select_all" @change="selectAll()" :id="`${table_id}_filter_selector_input`">
                                    <label class="custom-control-label" :for="`${table_id}_filter_selector_input`"></label>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody class="data-tables-spinner-body" v-show="loading">
                    <tr>
                        <td :colspan="headers.length">
                            <div class="d-flex align-items-center justify-content-center" :style="{ 'min-height': `${loader_height}px` }">
                                <div>
                                    <i class="fa fa-cog fa-spin fa-4x"></i>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody class="main-tbody" v-show="!loading">
                    <tr v-for="(row, row_index) in table_data[current_page]" :key="row_index">
                        <template v-for="(header, header_index) in headers">
                            <data-tables-selector-component 
                                v-if="header.key === 'selector_input'" 
                                :key="header_index" 
                                :col_key="header.key" 
                                :class="[header.cell_classes]" 
                                :elementId="row.id || 0" 
                                :table_id="table_id"
                            ></data-tables-selector-component>
                            <td v-else :key="header_index + '_else'" :col_key="header.key" :class="[header.cell_classes]" v-html="row[header.key]"></td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12" :id="`${table_id}_pagination`" v-if="page_count > 1">
            <nav>
                <ul class="pagination justify-content-center">
                    <li v-if="current_page == 1" class="page-item disabled" aria-disabled="true" aria-label="« First">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-fast-backward backward-button"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(1)" type="button" class="page-link" aria-label="« First">
                            <i class="fa fa-fast-backward backward-button backward-button"></i>
                        </button>
                    </li>

                    <li v-if="current_page == 1" class="page-item disabled" aria-disabled="true" aria-label="« Previuos">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-backward backward-button"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(current_page - 1)" type="button" class="page-link" rel="prev" aria-label="« Previuos">
                            <i class="fa fa-backward backward-button backward-button"></i>
                        </button>
                    </li>

                    <li class="page-item" v-for="(i, _) in [4, 3, 2, 1]" :key="`${_}-before`" v-show="current_page - i >= 1">
                        <button @click="changePage(current_page - i)" type="button" class="page-link">{{ current_page- i }}</button>
                    </li>

                    <li class="page-item active">
                        <button type="button" class="page-link">{{ current_page }}</button>
                    </li>

                    <li class="page-item" v-for="(i, _) in [1, 2, 3, 4]" :key="`${_}-after`" v-show="current_page + i <= page_count">
                        <button @click="changePage(current_page + i)" type="button" class="page-link">{{ current_page+ i }}</button>
                    </li>

                    <li v-if="current_page == page_count" class="page-item disabled" aria-disabled="true" aria-label="Next »">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-forward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(current_page + 1)" type="button" class="page-link" rel="next" aria-label="Next »">
                            <i class="fa fa-forward forward-button"></i>
                        </button>
                    </li>

                    <li v-if="current_page == page_count" class="page-item disabled" aria-disabled="true" aria-label="Last »">
                        <span class="page-link" aria-hidden="true">
                            <i class="fa fa-fast-forward"></i>
                        </span>
                    </li>
                    <li v-else class="page-item">
                        <button @click="changePage(page_count)" type="button" class="page-link" aria-label="Last »">
                            <i class="fa fa-fast-forward forward-button"></i>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            headers: [],
            filter_values: {},
            table_data: {},
            current_page: 1,
            per_page: 20,
            request_number: 1,
            header_keys: [],
            page_count: 1,
            loaded_pages: [],
            sorting_key: '',
            filter_timer: null,
            loading: true,
            loader_height: 100,
            select_all: 0,
        }
    },
    props: {
        table_id: {
            type: String,
            required: true,
        },
        sort_key: {
            type: String,
            required: false,
            default: 'id'
        },
        sort_dir: {
            type: String,
            required: false,
            default: 'asc',
        },
        headers_json: {
            type: String,
            required: true,
        },
        filter_header: {
            type: Boolean,
            required: false,
            default: false,
        },
        data_url: {
            type: String,
            required: true,
        },
        non_sorting: {
            type: Array,
            required: false,
            default: function () {
                return [];
            },
        },
        default_filters_json: {
            type: String,
            required: false,
        }
    },
    created: function () {
        let vue_this = this;

        vue_this.headers = JSON.parse(Base64.decode(vue_this.headers_json));

        vue_this.sorting_key = vue_this.sort_key;
        vue_this.sorting_direction = vue_this.sort_dir;

        $.each(vue_this.headers, function (index, element) {
            vue_this.header_keys.push(element['key']);
        });

        if (vue_this.default_filters_json !== undefined) {
            let filters = JSON.parse(Base64.decode(vue_this.default_filters_json));
            $.each(filters, function (index, element) {
                vue_this.filter_values[index] = element;
            });
        }

        vue_this.$nextTick(function () {
            let items = $(`#${vue_this.table_id}`).find('.vue-datatables-daterange-filter');

            let complete_locale = window.daterangepicker_locales[window.locale];
            complete_locale['format'] = 'YYYY-MM-DD';

            items.daterangepicker({
                'locale': complete_locale,
                'linkedCalendars': false,
            });

            items.on('apply.daterangepicker', function () {
                vue_this.filter_values[$(this).data('header-key')] = $(this).val();
                vue_this.filterInput();
            });

            items.on('cancel.daterangepicker', function () {
                vue_this.filter_values[$(this).data('header-key')] = null;
                vue_this.filterInput();
            });

            items.attr('autocomplete', 'off');

            items.each(function (index, element) {
                if (vue_this.filter_values[$(element).data('header-key')] !== undefined) {
                    let value = vue_this.filter_values[$(element).data('header-key')];
                    $(element).data('daterangepicker').setStartDate(value.split(' - ')[0]);
                    $(element).data('daterangepicker').setEndDate(value.split(' - ')[1]);
                }
            });
        });

        vue_this.completeDataRefresh();
    },
    methods: {
        sortCol(col_key) {
            let vue_this = this;

            if (vue_this.non_sorting.includes(col_key)) {
                return;
            }

            if (vue_this.sorting_key === col_key) {
                vue_this.sorting_direction = (vue_this.sorting_direction === 'desc' ? 'asc' : 'desc');
            } else {
                vue_this.sorting_direction = 'asc'
            }

            vue_this.sorting_key = col_key;
            vue_this.completeDataRefresh();
        },
        filterInput() {
            let vue_this = this;

            if (vue_this.filter_timer) {
                clearTimeout(vue_this.filter_timer);
                vue_this.filter_timer = null;
            }

            vue_this.filter_timer = setTimeout(function () {
                vue_this.completeDataRefresh();
            }, 250);
        },
        completeDataRefresh() {
            let vue_this = this;

            vue_this.loader_height = $(`#${vue_this.table_id}`).find('.main-tbody').outerHeight();
            vue_this.loading = true;
            vue_this.current_page = 1;
            vue_this.table_data = {};
            vue_this.loaded_pages = [];

            vue_this.loadCurrent_page();
        },
        loadCurrent_page() {
            let vue_this = this;

            if (vue_this.loaded_pages.includes(vue_this.current_page)) {
                vue_this.loading = false;
                return;
            }

            vue_this.request_number++;

            let requestData = {
                request_number: vue_this.request_number,
                sort_key: vue_this.sorting_key,
                sort_dir: vue_this.sorting_direction,
                page: vue_this.current_page,
                per_page: vue_this.per_page,
                columns: vue_this.header_keys,
                filters: vue_this.filter_values,
            };

            axios.post(vue_this.data_url, requestData)
                .then(function (response) {
                    if (response.data.request_number != vue_this.request_number) {
                        return;
                    }

                    vue_this.current_page = parseInt(response.data.page);
                    vue_this.page_count = parseInt(response.data.totalPages);

                    if (response.data.table_data.length > 0) {
                        vue_this.table_data[vue_this.current_page] = response.data.table_data;
                        vue_this.loaded_pages.push(response.data.page);
                    }

                    vue_this.loading = false;

                    vue_this.$forceUpdate();
                })
                .catch(function (error) {
                    console.error(error);
                });

        },
        changePage(newPage) {
            let vue_this = this;
            if (newPage < 0 || newPage > vue_this.totalPages || newPage == vue_this.current_page) {
                return;
            }

            vue_this.loader_height = $(`#${vue_this.table_id}`).find('.main-tbody').outerHeight();
            vue_this.loading = true;
            vue_this.current_page = newPage;
            vue_this.loadCurrent_page();
        },
        selectAll: function () {
            $(`#${this.table_id}`).find('.table_selector_input').prop('checked', this.select_all);
        }
    },
}
</script>
